var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Container',{staticClass:"bg-white",attrs:{"title":_vm.title,"toggle-visiblity":_vm.showToggleVisiblity}},[_c('avatar-list',{attrs:{"profiles":_vm.responsibleUsers}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }